import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MapService } from './map.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private http: HttpClient, private _mapService: MapService) {}

  getAlerts(filters, isFilterZone: boolean = false): Observable<any[]> {
    
    const { startDate, endDate, type, state , value} = filters;

    let params =
      type > 0
        ? `?date__gte=${startDate}&date__lte=${endDate}&alert_type=${type}`
        : `?date__gte=${startDate}&date__lte=${endDate}`;

    if (state != '') {
      params = params + `&state=${state}`;
    }
    if(value){
      params = params + `&value=${value}`;
    }
    if(isFilterZone){
      const bounds = this._mapService.map.getBounds();
      const southwest = bounds.getSouthWest();
      const northeast = bounds.getNorthEast();
      const inBbox = `${northeast.lng},${northeast.lat},${southwest.lng},${southwest.lat}`;
      params = params  + `&in_bbox=${inBbox}`
    }
    let url = `${environment.url}/notification/${params}`;
    return this.http.get<any[]>(url);
  }

  getAlertTypes(): Observable<any[]> {
    let url = `${environment.url}/notification/types`;
    return this.http.get<any[]>(url);
  }

  getAlertsCounts(): Observable<any> {
    let url = `https://data.ecopetrol.taskgo.co/api/alerts/`;
    return this.http.get<{ count: number }>(url);
  }

  updateAlertState(id: string) {
    let url = `https://api.ecopetrol.taskgo.co/notification/${id}`;
    return this.http.patch<any>(url, { id, state: 'IMPLEMENTED' });
  }
}
